import React from 'react';
import { Divider, Dialog, DialogContent } from '@mui/material';
import styles from '../../../custom/style.module.css';
import { CustomButton, CustomDialogTitle, CustomDialogAction } from '../../../custom/components';
import { CloseIconBtn } from 'custom/constants';

const MultiAwbModal = (props) => {
  return (
    <div>
      <Dialog aria-labelledby='form-dialog-title' open={props.modal} onClose={props.onClose}>
        <CustomDialogTitle id='form-dialog-title'>
          Multiple documents are linked to this AWB.
          <CloseIconBtn onClick={props.onClose} />
        </CustomDialogTitle>
        <Divider />
        <DialogContent sx={{ width: 600 }}>
          Would you like to rename only the selected document, or apply the new name to all documents linked to this AWB?
        </DialogContent>
        <CustomDialogAction className={`${styles.fSpaceBtw}`}>
          <CustomButton variant='contained' onClick={props.createNewAWB}>Rename Selected Only</CustomButton>
          <CustomButton variant='contained' onClick={props.editExistingAWB}>Rename All Documents</CustomButton>
        </CustomDialogAction>
      </Dialog>
    </div>
  );
};
export default MultiAwbModal;